import * as S from "./style";

import { advantagesInfo } from "./data";

export default function Template() {
  return (
    <S.Wrapper id={"test-div"}>
      <S.Titile>SW캠프가 다른 이유</S.Titile>
      <S.Advantages>
        {advantagesInfo.map(({ number, advantage, desc }) => (
          <S.AdvantageWrapper key={number}>
            <S.Number>{number}</S.Number>
            <article>
              <S.Advantage>{advantage}</S.Advantage>
              <S.Desc>{desc}</S.Desc>
            </article>
          </S.AdvantageWrapper>
        ))}
      </S.Advantages>
    </S.Wrapper>
  );
}
